import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useI18n } from "../i18n";
import { get } from "../lib/api";
import { usePub } from "./PublicSite";

export const usePublicApi = (url, lang) => {
  const key = `${url}|${lang}`;
  const [state, setState] = useState(() => ({ data: window.__amPre?.[key] || null, error: null }));
  useEffect(() => {
    let live = true;
    const pre = window.__amPre?.[key];
    if (pre) { delete window.__amPre[key]; setState({ data: pre, error: null }); return undefined; }
    setState({ data: null, error: null });
    get(url, { lang }).then((data) => live && setState({ data, error: null })).catch((error) => live && setState({ data: null, error }));
    return () => { live = false; };
  }, [url, lang, key]);
  return state;
};

export const coverSrc = (url) => `${process.env.REACT_APP_BACKEND_URL}${url}`;

const srcset = (url, f) => [480, 768, 1264].map((w) => `${coverSrc(url)}?w=${w}&f=${f} ${w}w`).join(", ");

export const Cover = ({ url, eager = false, sizes = "(min-width: 800px) 760px, 100vw", className, testId }) => (
  <picture>
    <source type="image/avif" srcSet={srcset(url, "avif")} sizes={sizes} />
    <source type="image/webp" srcSet={srcset(url, "webp")} sizes={sizes} />
    <img className={className} src={`${coverSrc(url)}?w=768&f=webp`} alt="" width="1264" height="848" loading={eager ? "eager" : "lazy"}
         decoding="async" fetchPriority={eager ? "high" : undefined} data-testid={testId} />
  </picture>
);

export const FreeCta = ({ id }) => {
  const { t } = useI18n();
  return (
    <aside className="pub-free-cta" data-testid={`free-cta-${id}`}>
      <div>
        <p className="pub-free-cta-h">{t("blog.ctaTitle")}</p>
        <p className="pub-muted m-0">{t("blog.ctaBody")}</p>
      </div>
      <Link to="/signup" className="pub-btn pub-btn-dark" data-testid={`free-cta-button-${id}`}><span>{t("blog.ctaButton")}</span><ArrowRight className="rtl-flip h-4 w-4" /></Link>
    </aside>
  );
};

export const NotFound = ({ back, label }) => {
  const { lang } = usePub();
  return (
    <div className="pub-section"><div className="pub-wrap" data-testid="public-not-found">
      <p className="pub-muted">404</p><Link to={`/${lang}${back}`} className="pub-link" data-testid="public-not-found-back">{label}</Link>
    </div></div>
  );
};

export const Loading = () => <div className="pub-section"><div className="pub-wrap pub-skel" data-testid="public-loading" /></div>;
